var map = {
	"./font/fons_1.otf": "u5Zg",
	"./font/fons_2.otf": "Y/2f",
	"./font/fons_3.ttf": "bO7M",
	"./font/huakang.ttf": "p/5A",
	"./font/pan.ttf": "ZKr+",
	"./font/siyuanH.otf": "dbAB",
	"./font/siyuanS.otf": "h4iB",
	"./greytabbt.png": "qRem",
	"./logo.png": "7Otq",
	"./tabbt_1.png": "HMH+",
	"./tabbt_2.png": "Y+j7",
	"./tabbt_3.png": "V8oO",
	"./tabbt_4.png": "YnUu",
	"./xi_1.jpg": "LLjp",
	"./xi_11.jpg": "7IBj",
	"./xi_111.jpg": "oScQ",
	"./xi_112.jpg": "jqhs",
	"./xi_12.jpg": "rxnq",
	"./xi_2.jpg": "R5SV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1